/* Tishya size guide modal. Data + initial tab come from snippets/size-guide.liquid */
(function () {
  function init() {
    var CFG = window.TISHYA_SIZE_GUIDE;
    var overlay = document.querySelector('[data-sg-overlay]');
    if (!CFG || !overlay) return;

    var panel = overlay.querySelector('[data-sg-panel]');
    var titleEl = overlay.querySelector('[data-sg-title]');
    var fitEl = overlay.querySelector('[data-sg-fit]');
    var tableEl = overlay.querySelector('[data-sg-table]');
    var inseamDt = overlay.querySelector('[data-sg-inseam-dt]');
    var inseamDd = overlay.querySelector('[data-sg-inseam-dd]');
    var unitBtn = overlay.querySelector('[data-sg-unit]');
    var tabs = overlay.querySelectorAll('[data-sg-tab]');

    var state = { tab: CFG.tab || 'tops', inch: true };
    var guide = CFG.data[CFG.gender] || CFG.data.women;
    var lastFocus = null;

    function render() {
      var set = guide[state.tab];
      titleEl.textContent = guide.label;
      fitEl.textContent = set.fit || '';

      var html =
        '<table class="sg-table"><thead><tr><th class="sg-rowh">Measurement</th>' +
        '<th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th></tr></thead><tbody>';
      set.rows.forEach(function (row) {
        html += '<tr><td class="sg-rowh">' + row[0] + '</td>';
        row[1].forEach(function (cell) {
          html += '<td>' + (state.inch ? cell[0] : cell[1]) + '</td>';
        });
        html += '</tr>';
      });
      html += '</tbody></table>';
      tableEl.innerHTML = html;

      inseamDt.hidden = !set.inseam;
      inseamDd.hidden = !set.inseam;

      tabs.forEach(function (t) {
        var on = t.getAttribute('data-sg-tab') === state.tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      unitBtn.classList.toggle('is-inch', state.inch);
    }

    function open() {
      lastFocus = document.activeElement;
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      render();
      var closeBtn = overlay.querySelector('[data-sg-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      overlay.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    // Triggers are rendered inside the Size legend; bind by delegation so it
    // still works after the variant picker re-renders on variant change.
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-sg-open]');
      if (trigger) {
        e.preventDefault();
        open();
        return;
      }
      if (e.target.closest('[data-sg-close]')) {
        close();
        return;
      }
      // click on the dimmed backdrop, outside the panel
      if (!overlay.hidden && e.target === overlay) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        state.tab = t.getAttribute('data-sg-tab');
        render();
      });
    });

    unitBtn.addEventListener('click', function () {
      state.inch = !state.inch;
      render();
    });

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
